<template>
  <div class="init-config-course-step pa-4">
    <!-- 客数 (先に決める) -->
    <v-card-subtitle class="pa-0 mb-3 text-base">
      客数
    </v-card-subtitle>

    <div class="d-flex align-center justify-start customer-counter mb-6">
      <v-btn
        fab
        color="error"
        x-large
        :disabled="customerCount <= 0"
        class="counter-btn"
        @click="handleCountChange(customerCount - 1)"
      >
        <v-icon large>
          {{ icons.mdiMinus }}
        </v-icon>
      </v-btn>

      <div class="counter-value mx-6 d-flex align-center">
        <v-icon
          large
          class="mr-2"
        >
          {{ icons.mdiAccountOutline }}
        </v-icon>
        <span class="text-h3 font-weight-bold">{{ customerCount || 0 }}</span>
        <span class="ml-2 text-h6">名</span>
      </div>

      <v-btn
        fab
        color="primary"
        x-large
        class="counter-btn"
        @click="handleCountChange(customerCount + 1)"
      >
        <v-icon large>
          {{ icons.mdiPlus }}
        </v-icon>
      </v-btn>
    </div>

    <!-- コース選択 (人数が入ったら表示) -->
    <div v-if="customerCount > 0">
      <v-card-subtitle class="pa-0 mb-3 text-base">
        コースを選択してください
      </v-card-subtitle>

      <v-row dense>
        <v-col
          v-for="course in courses"
          :key="course.id"
          cols="12"
          sm="6"
          md="4"
        >
          <init-config-course-card
            :course="course"
            :selected="course.id === selectedCourseId"
            @select="handleSelect"
          />
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mdiPlus, mdiMinus, mdiAccountOutline } from '@mdi/js'
import InitConfigCourseCard from '../parts/InitConfigCourseCard.vue'

export default {
  name: 'InitConfigCourseStep',
  components: { InitConfigCourseCard },
  props: {
    courses: { type: Array, required: true },
    selectedCourseId: { type: [Number, String], default: null },
    customerCount: { type: Number, default: 0 },
  },
  emits: ['update:selectedCourseId', 'update:customerCount'],
  setup(_, { emit }) {
    const handleSelect = course => {
      emit('update:selectedCourseId', course.id)
    }

    const handleCountChange = next => {
      emit('update:customerCount', Math.max(0, Number(next) || 0))
    }

    return {
      handleSelect,
      handleCountChange,
      icons: { mdiPlus, mdiMinus, mdiAccountOutline },
    }
  },
}
</script>
